export const env = {
  baseURL: process.env.REACT_APP_API_BASE_URL || "",
  openseaBaseUrl: process.env.REACT_APP_OPENSEA_BASE_URL || "",
  pinataBaseUrl: process.env.REACT_APP_PINATA_BASE_URL || "",
  infuraUrl: process.env.REACT_APP_INFURA_URL || "",
  gasPrice: process.env.REACT_APP_GAS_PRICE || "",
  contractAddress: process.env.REACT_APP_CONTRACT_ADDRESS || ""
};
